module.exports = __webpack_public_path__ + "media/images/common/my_menu_bill-45d0b5c7e89d3086e3c61e36107c63ae.png";